export default {
  validate: {
    method: 'post',
    url: '/partner/order/allotment/validate/ORDER_ID'
  },
  add: {
    method: 'post',
    url: '/partner/order/allotment/ORDER_ID'
  },
  addVendor: {
    method: 'post',
    url: '/partner/order/allotment/ORDER_ID/add-vendor'
  }
}
